var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceNonCredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5954_9392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 20L13.5 18.5739L9 20L4.5 18.5739L0 20V0H12.6L18 5.21739V20Z",
    fill: "#5DDE8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6 5.27826H18L12.6 0V5.27826Z",
    fill: "#086D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.274 7.46094H4.42798V8.18268H14.274V7.46094Z",
    fill: "#086D2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.274 10.4783H4.42798V11.2H14.274V10.4783Z",
    fill: "#086D2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5954_9392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceNonCredit);
export default __webpack_public_path__ + "static/media/InvoiceNonCredit.9f61ec6341502ad0baf604ac58cba3b5.svg";
export { ForwardRef as ReactComponent };